import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { CardRow } from '../Card';

interface IPageHeaderProps {
  appearance?: 'default' | 'transparent';
  hasStats?: boolean;
  dataCy?: string;
}

const PADDING = `${toRem(theme.page.header.padding.small)} ${toRem(theme.layout.gutter.small)}`;
const PADDING_LARGE = `${toRem(theme.page.header.padding.large)} ${toRem(theme.layout.gutter.large)}`;

const PageHeader = styled.header.attrs<IPageHeaderProps>((props) => ({
  'data-cy': props.dataCy || 'page-header',
}))<IPageHeaderProps>`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: ${toRem(theme.layout.gutter.small)};
  padding: ${PADDING};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: ${theme.color.neutral[800]};
  gap: ${toRem(8)};

  @media (min-width: ${theme.breakpoint.small}px) {
    margin-bottom: ${toRem(theme.page.header.padding.large)};
    padding: ${PADDING_LARGE};
  }

  ${({ appearance }) =>
    appearance === 'transparent' &&
    css`
      background-color: transparent;
    `}

  ${({ hasStats }) =>
    hasStats &&
    css`
      margin-bottom: ${toRem(44)};
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;
      border-bottom: none;

      @media (min-width: ${theme.breakpoint.small}px) {
        margin-bottom: ${toRem(-77)};
        padding-right: 0;
        padding-bottom: 0;
        padding-left: 0;
        border-bottom: none;
      }

      > * {
        width: 100%;
        padding: 0 ${toRem(theme.layout.gutter.small)};

        @media (min-width: ${theme.breakpoint.small}px) {
          padding: 0 ${toRem(theme.layout.gutter.large)};
        }
      }
    `}


  ${CardRow} {
    margin-top: ${toRem(theme.layout.gutter.small)};
    margin-bottom: 0;
    padding-top: ${toRem(theme.layout.gutter.small)};
    border-top: ${toRem(1)} solid ${theme.color.neutral[200]};
    background-color: ${theme.color.white};

    @media (min-width: ${theme.breakpoint.small}px) {
      margin-top: ${toRem(theme.card.minHeight.large / 2 + 22)};
      padding-top: ${toRem(theme.card.minHeight.large / 2)};

      > div {
        top: ${toRem(-theme.card.minHeight.large)};
      }
    }
  }
`;

export default PageHeader;
